export interface EntrydeviceInterface {
  /**
   * 是否是本机
   */
  isCurrent?: boolean
  operatedAt?: string | null
  device?: string
  os?: string
  browser?: string
  address?: string
}

export class Entrydevice implements EntrydeviceInterface {
  /**
   * 是否是本机
   */
  isCurrent?: boolean
  operatedAt?: string | null
  device?: string
  os?: string
  browser?: string
  address?: string

  constructor(props: EntrydeviceInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      isCurrent: _isCurrent,
      operatedAt: _operatedAt,
      device: _device,
      os: _os,
      browser: _browser,
      address: _address,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.isCurrent = _isCurrent
    this.operatedAt = _operatedAt
    this.device = _device
    this.os = _os
    this.browser = _browser
    this.address = _address
  }
}
